/* BICH Broschüre: Kategorien-Mega-Menü (Desktop-Panel / mobile Off-Canvas mit Drill-down) */
(function () {
  if (customElements.get('bichb-megamenu')) return;
  const MQ = window.matchMedia('(max-width: 989px)');
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  class BichbMegaMenu extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.bichb-mm__toggle');
      this.panel = this.querySelector('.bichb-mm__panel');
      this.overlay = this.querySelector('.bichb-mm__overlay');
      this.groups = Array.from(this.querySelectorAll('[data-mm-group]'));
      this.panes = Array.from(this.querySelectorAll('[data-mm-pane]'));
      if (!this.toggle || !this.panel) return;

      this.toggle.addEventListener('click', () => (this.isOpen() ? this.close(true) : this.open()));
      this.querySelectorAll('[data-mm-close]').forEach((el) => el.addEventListener('click', () => this.close(true)));
      this.querySelectorAll('[data-mm-back]').forEach((el) => el.addEventListener('click', () => this.back()));

      this.groups.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.activate(btn.dataset.mmGroup);
          if (MQ.matches) this.drill();
        });
        btn.addEventListener('mouseenter', () => {
          if (!MQ.matches) this.activate(btn.dataset.mmGroup);
        });
        btn.addEventListener('focus', () => {
          if (!MQ.matches) this.activate(btn.dataset.mmGroup);
        });
        btn.addEventListener('keydown', (e) => this.onGroupKey(e, btn));
      });

      this.onKeydown = this.onKeydown.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.onFocusOut = this.onFocusOut.bind(this);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('focusout', this.onFocusOut);
      MQ.addEventListener('change', () => this.close(false));
    }

    isOpen() {
      return this.toggle.getAttribute('aria-expanded') === 'true';
    }

    open() {
      const mobile = MQ.matches;
      this.panel.hidden = false;
      this.overlay.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
      document.body.classList.add('bichb-mm-open');
      if (mobile) {
        this.panel.setAttribute('aria-modal', 'true');
        document.body.classList.add('bichb-mm-lock');
        this.undrill();
        this.activate(null);
      } else {
        this.panel.removeAttribute('aria-modal');
        const current = this.groups.find((g) => g.getAttribute('aria-expanded') === 'true') || this.groups[0];
        if (current) this.activate(current.dataset.mmGroup);
      }
      document.addEventListener('click', this.onDocClick);
      const first = mobile ? this.groups[0] || this.panel.querySelector(FOCUSABLE) : this.groups[0];
      if (first) requestAnimationFrame(() => first.focus({ preventScroll: true }));
    }

    close(returnFocus) {
      if (!this.isOpen()) return;
      this.panel.hidden = true;
      this.overlay.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');
      document.body.classList.remove('bichb-mm-open', 'bichb-mm-lock');
      document.removeEventListener('click', this.onDocClick);
      this.undrill();
      if (returnFocus) this.toggle.focus();
    }

    activate(id) {
      this.groups.forEach((g) => g.setAttribute('aria-expanded', String(g.dataset.mmGroup === id)));
      this.panes.forEach((p) => (p.hidden = p.dataset.mmPane !== id));
    }

    drill() {
      this.panel.classList.add('is-drilled');
      const pane = this.panes.find((p) => !p.hidden);
      const back = pane && pane.querySelector('[data-mm-back]');
      if (back) back.focus();
    }

    undrill() {
      this.panel.classList.remove('is-drilled');
    }

    back() {
      const open = this.groups.find((g) => g.getAttribute('aria-expanded') === 'true');
      this.undrill();
      this.activate(null);
      if (open) open.focus();
    }

    onGroupKey(e, btn) {
      const i = this.groups.indexOf(btn);
      let next = null;
      if (e.key === 'ArrowDown') next = this.groups[(i + 1) % this.groups.length];
      if (e.key === 'ArrowUp') next = this.groups[(i - 1 + this.groups.length) % this.groups.length];
      if (e.key === 'Home') next = this.groups[0];
      if (e.key === 'End') next = this.groups[this.groups.length - 1];
      if (e.key === 'ArrowRight' && !MQ.matches) {
        const pane = this.panes.find((p) => p.dataset.mmPane === btn.dataset.mmGroup);
        const link = pane && pane.querySelector('a[href]');
        if (link) {
          e.preventDefault();
          link.focus();
        }
        return;
      }
      if (next) {
        e.preventDefault();
        next.focus();
      }
    }

    onKeydown(e) {
      if (!this.isOpen()) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        this.close(true);
        return;
      }
      if (e.key === 'Tab' && MQ.matches) {
        /* Fokusfalle in der mobilen Seitenleiste (modal) */
        const items = Array.from(this.panel.querySelectorAll(FOCUSABLE)).filter(
          (el) => el.offsetParent !== null || el === document.activeElement
        );
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    onFocusOut(e) {
      if (!this.isOpen() || MQ.matches) return;
      const to = e.relatedTarget;
      if (to && !this.contains(to)) this.close(false);
    }

    onDocClick(e) {
      if (!this.contains(e.target)) this.close(false);
    }
  }

  customElements.define('bichb-megamenu', BichbMegaMenu);
})();
